import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueTelInput from 'vue-tel-input'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/pc_style.less'
import './assets/iconfont/iconfont.css'
import './assets/googleIconfont/iconfont.css'
import './assets/css/mobile_style.less'
import './assets/css/index.less'
// import './assets/js/gVerify';
import Api from './service/api.js'
import VueAxios from 'vue-axios'
import i18n from '@/assets/lang/index'
import preventClick from './assets/js/preventClick.js'
import 'babel-polyfill'
import { CookieSettings, GoogleLoginTip, TopHeader } from 'tvu-common-ui'
Vue.use(CookieSettings)
Vue.use(GoogleLoginTip)
Vue.use(TopHeader)
Vue.prototype.$TVU = {
  isUserService: true
}

Vue.prototype.qs = require('qs')
// Vue.use(ElementUI);
Vue.use(VueTelInput, {
  enabledCountryCode: true,
  inputClasses: 'telephone',
  placeholder: 'Phone number',
  validCharactersOnly: true,
  defaultCountry: '',
  mode: 'national',
  customValidate: false
})
Vue.use(preventClick)
Vue.use(VueAxios, Api.axios)
Vue.use(ElementUI, {
  i18n: (key, val) => i18n.t(key, val) // 用于elementUI插件的中英文翻译
})
Vue.config.productionTip = false
if (process.env.NODE_ENV != 'development') {
  window.console.log = function () { }
  window.console.info = function () { }
  window.console.error = function () { }
}
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
